<template>
  <div>
    <Row v-if="bussiness.category=='S'">
      <Row class="detail-content">
        <slot name="info-title"></slot>
        <Col :span="labelWidth" class="left-label">主体性质：</Col>
        <Col :span="contentWidth" class="right-content">{{ bussiness.property=='P'?'个人':(bussiness.property=='E'?'企业':'个体工商户') }}</Col>
        <Col :span="labelWidth" class="left-label">主体名称：</Col>
        <Col
          :span="contentWidth" class="right-content textover"
          :title="bussiness.name"
        >{{ bussiness.name }}</Col>

        <Col :span="labelWidth" class="left-label">主体标签：</Col>
        <Col :span="contentWidth" class="right-content">{{ bussiness.type=='E'?'经营主体':(bussiness.type=='B'?'开票主体':'POS机主体') }}</Col>
        <Col :span="labelWidth" class="left-label">{{ bussiness.property=='P'?'身份证号':(bussiness.property=='E'?'信用代码':'信用代码') }}：</Col>
        <Col
          :span="contentWidth" class="right-content textover"
          :title="bussiness.legalRepresentative"
        >
          {{ bussiness.creditCode || "" }}
        </Col>

        <Col
          v-if="bussiness.property!='P'" :span="labelWidth"
          class="left-label"
        >{{ bussiness.property=='E'?'法定代表人':'经营者' }}：</Col>
        <Col
          v-if="bussiness.property!='P'" :span="contentWidth"
          class="right-content textover" :title="bussiness.legalRepresentative"
        >{{ bussiness.legalRepresentative }}</Col>
        <Col
          v-if="bussiness.property!='P'&&bussiness.property!='E'" :span="labelWidth"
          class="left-label"
        >经营者身份证号</Col>
        <Col
          v-if="bussiness.property!='P'&&bussiness.property!='E'" :span="contentWidth"
          class="right-content textover" :title="bussiness.legalIdNo"
        >{{ bussiness.legalIdNo }}</Col>
        <Col>
          <Col :span="labelWidth" class="left-label">联系方式：</Col>
          <Col :span="contentWidth" class="right-content textover">{{ bussiness.contact }}</Col>
        </Col>
        <Col :span="labelWidth" class="left-label">主体区域：</Col>
        <Col
          :span="contentWidth" class="right-content textover"
          :title="bussiness.provinceName+bussiness.cityName+bussiness.areaName"
        >
          {{ bussiness.provinceName }} {{ bussiness.cityName }} {{ bussiness.areaName }}
        </Col>
        <Col :span="labelWidth" class="left-label">工商登记地址：</Col>
        <Col
          :span="contentWidth" class="right-content textover"
          :title="bussiness.address"
        >{{ bussiness.address }}</Col>
        <Col v-if="identifyShow">
          <Col :span="labelWidth" class="left-label">认定依据图片：</Col>
          <Col :span="contentWidth" class="right-content">
            <file-upload
              :default-list="bussiness.attachmentList || []"
              :upload-config="{readOnly:true}"
            />
          </Col>
          <Col :span="labelWidth" class="left-label">认定依据描述：</Col>
          <Col :span="contentWidth" class="right-content textover">{{ bussiness.identifyRemark || "" }}</Col>
        </Col>
        <!-- 线上案件才显示订单号 -->
        <Col v-if="tortCategory === 2">
          <Col :span="labelWidth" class="left-label">订单号：</Col>
          <Col
            :span="contentWidth" class="right-content textover"
            :title="bussiness.platformOrderNo"
          >{{ bussiness.platformOrderNo }}</Col>
        </Col>
      </Row>
    </Row>
    <Row v-if="bussiness.category=='M'">
      <Row class="detail-content">
        <slot name="info-title"></slot>
        <Col :span="labelWidth" class="left-label">主体性质：</Col>
        <Col :span="contentWidth" class="right-content">{{ bussiness.property=='E'?'企业':'个体工商户' }}</Col>
        <Col :span="labelWidth" class="left-label">生产商名称：</Col>
        <Col :span="contentWidth" class="right-content">{{ bussiness.name || "" }}</Col>
        <Col :span="labelWidth" class="left-label">信用代码：</Col>
        <Col :span="contentWidth" class="right-content">{{ bussiness.creditCode || "" }}</Col>
        <Col :span="labelWidth" class="left-label">{{ bussiness.property=='I'? '经营者：':'法定代表人：' }}  </Col>
        <Col :span="7" class="right-content">{{ bussiness.legalRepresentative || "" }}</Col>
        <Col :span="4" class="left-label"> {{ bussiness.property=='I'? '经营者身份证：':'法定代表人身份证：' }}  </Col>
        <Col :span="contentWidth" class="right-content">{{ bussiness.legalIdNo || "" }}</Col>
        <Col :span="labelWidth" class="left-label">联系方式：</Col>
        <Col :span="contentWidth" class="right-content textover">{{ bussiness.contact }}</Col>
        <Col :span="labelWidth" class="left-label">主体区域：</Col>
        <Col
          :span="contentWidth" class="right-content"
          :title="bussiness.provinceName+bussiness.cityName+bussiness.areaName"
        >
          {{ bussiness.provinceName || "" }} {{ bussiness.cityName || "" }} {{ bussiness.areaName || "" }}
        </Col>
        <Col :span="labelWidth" class="left-label">工商登记地址：</Col>
        <Col :span="contentWidth" class="right-content">{{ bussiness.address || "" }}</Col>
        <Col v-if="identifyShow">
          <Col :span="labelWidth" class="left-label">认定依据图片：</Col>
          <Col :span="contentWidth" class="right-content">
            <file-upload
              :default-list="bussiness.attachmentList || []"
              :upload-config="{readOnly:true}"
            />
          </Col>
          <Col :span="labelWidth" class="left-label">认定依据描述：</Col>
          <Col :span="contentWidth" class="right-content textover">{{ bussiness.identifyRemark || "" }}</Col>
        </Col>
        <Col v-if="tortCategory === 2 && bussiness.platformOrderNo">
          <Col :span="labelWidth" class="left-label">订单号：</Col>
          <Col
            :span="contentWidth" class="right-content textover"
            :title="bussiness.platformOrderNo"
          >{{ bussiness.platformOrderNo }}</Col>
        </Col>
      </Row>
    </Row>
  </div>
</template>
<script>
import styles from '@/assets/globalStyle.scss'
export default {
  components: {},
  props: {
    defaultData: {
      type: Object,
      default() {
        return {}
      }
    },
    double: {
      type: Boolean,
      default: true
    },
    identifyShow: {
      type: Boolean,
      default: false
    },
    tortCategory: { // 线上：2、线下：1
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      bussiness: {},
      labelWidth: '3',
      contentWidth: '8'
    }
  },
  watch: {},
  created() {},
  beforeMount() {},
  mounted() {
    this.bussiness = this.defaultData
    if (this.double) {
      this.labelWidth = '3'
      this.contentWidth = '8'
    } else {
      this.labelWidth = '5'
      this.contentWidth = '16'
    }
  },
  updated() {},
  methods: {}
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/view/clue/myClue/plugin/tortSubjectInfo.vue